import UserCreateIndex from './create/UserCreateIndex'
import UserLogIndex from './log/UserLogIndex'
import UserIndex from './view/UserIndex'
// import PerfilConfig from './config/PerfilConfig'

const userRoutes = [
    {
        path: '/usuario',
        exact: true,
        component: UserIndex,
    },
    {
        path: '/usuario/novo',
        exact: true,
        component: UserCreateIndex,
    },
    {
        path: '/usuario/edit/:userId',
        exact: true,
        component: UserCreateIndex,
    },
    {
        path: '/usuario/log/:userId',
        exact: true,
        component: UserLogIndex,
    },
]

export default userRoutes
